export default __webpack_public_path__ + "static/media/ecomigration.da7fc6e0.png";